<app-layer-config-collapsible-category
  description="Warnings"
  storageKey="simulation-warnings"
  [collapsedDefault]="false"
>
  <app-layer-control-item
    description="Accidents"
    [isLayerVisibile]="isAccidentsLayerVisible"
    [layerId]="Layers.VAWarning.name"
    icon="car-crash"
    (visibilityToggled)="toggleLayerVisbility($event)"
    *hasPermissionAny="Layers.VAWarning.permissions"
  ></app-layer-control-item>
  <app-layer-control-item
    description="BDV"
    [isLayerVisibile]="isBdvLayerVisible"
    [layerId]="Layers.BDVWarning.name"
    icon="car-mechanic"
    (visibilityToggled)="toggleLayerVisbility($event)"
    *hasPermissionAny="Layers.BDVWarning.permissions"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Traction Loss"
    [isLayerVisibile]="isTLLayerVisible"
    [layerId]="Layers.TLWarning.name"
    icon="wheel-vehicle"
    (visibilityToggled)="toggleLayerVisbility($event)"
    *hasPermissionAny="Layers.TLWarning.permissions"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Construction Sites"
    [isLayerVisibile]="isCSLayerVisible"
    [layerId]="Layers.CSWarning.name"
    icon="construction"
    (visibilityToggled)="toggleLayerVisbility($event)"
    *hasPermissionAny="Layers.CSWarning.permissions"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Low Visibility"
    [isLayerVisibile]="isLVLayerVisible"
    [layerId]="Layers.LVWarning.name"
    icon="weather-mist"
    (visibilityToggled)="toggleLayerVisbility($event)"
    *hasPermissionAny="Layers.LVWarning.permissions"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Heavy Rain"
    [isLayerVisibile]="isHRLayerVisible"
    [layerId]="Layers.HRWarning.name"
    icon="weather-rain-warning"
    (visibilityToggled)="toggleLayerVisbility($event)"
    *hasPermissionAny="Layers.HRWarning.permissions"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Heavy Snow"
    [isLayerVisibile]="isHSLayerVisible"
    [layerId]="Layers.HSWarning.name"
    icon="ice"
    (visibilityToggled)="toggleLayerVisbility($event)"
    *hasPermissionAny="Layers.HSWarning.permissions"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Strong Wind"
    [isLayerVisibile]="isSWLayerVisible"
    [layerId]="Layers.SWWarning.name"
    icon="wind-vane-moderate"
    (visibilityToggled)="toggleLayerVisbility($event)"
    *hasPermissionAny="Layers.SWWarning.permissions"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Poor Road"
    [isLayerVisibile]="isPRLayerVisible"
    [layerId]="Layers.PRWarning.name"
    icon="mold"
    (visibilityToggled)="toggleLayerVisbility($event)"
    *hasPermissionAny="Layers.PRWarning.permissions"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Wrong Way Driver"
    [isLayerVisibile]="isWWDLayerVisible"
    [layerId]="Layers.WWDWarning.name"
    icon="user-hand-stop"
    (visibilityToggled)="toggleLayerVisbility($event)"
    *hasPermissionAny="Layers.WWDWarning.permissions"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Item on Road"
    [isLayerVisibile]="isIORLayerVisible"
    [layerId]="Layers.IORWarning.name"
    icon="truck-box"
    (visibilityToggled)="toggleLayerVisbility($event)"
    *hasPermissionAny="Layers.IORWarning.permissions"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Amber light"
    [isLayerVisibile]="isALLayerVisible"
    [layerId]="Layers.ALWarning.name"
    icon="emergency-front"
    (visibilityToggled)="toggleLayerVisbility($event)"
    *hasPermissionAny="Layers.ALWarning.permissions"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Blue light"
    [isLayerVisibile]="isBLLayerVisible"
    [layerId]="Layers.BLWarning.name"
    icon="siren"
    (visibilityToggled)="toggleLayerVisbility($event)"
    *hasPermissionAny="Layers.BLWarning.permissions"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Stopped Vehicle"
    [isLayerVisibile]="isSVLayerVisible"
    [layerId]="Layers.SVWarning.name"
    icon="car"
    (visibilityToggled)="toggleLayerVisbility($event)"
    *hasPermissionAny="Layers.SVWarning.permissions"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Traffic Jam"
    [isLayerVisibile]="isTJTLayerVisible"
    [layerId]="Layers.TJTWarning.name"
    icon="cars-traffic"
    (visibilityToggled)="toggleLayerVisbility($event)"
    *hasPermissionAny="Layers.TJTWarning.permissions"
  ></app-layer-control-item>
</app-layer-config-collapsible-category>
